"use strict";
exports.__esModule = true;
exports.ResourceType = void 0;
var ResourceType;
(function (ResourceType) {
    ResourceType["Link"] = "Link";
    ResourceType["Category"] = "Category";
})(ResourceType || (ResourceType = {}));
exports.ResourceType = ResourceType;
